'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_AppPageInit$$anon$1(outer) {
  this.aXx = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.aXx = outer;
}
export { $c_Lapp_pages_AppPageInit$$anon$1 as $c_Lapp_pages_AppPageInit$$anon$1 };
$p = $c_Lapp_pages_AppPageInit$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lapp_pages_AppPageInit$$anon$1;
/** @constructor */
function $h_Lapp_pages_AppPageInit$$anon$1() {
}
export { $h_Lapp_pages_AppPageInit$$anon$1 as $h_Lapp_pages_AppPageInit$$anon$1 };
$h_Lapp_pages_AppPageInit$$anon$1.prototype = $p;
$p.Ee = (function(x) {
  return true;
});
$p.DM = (function(x, default$1) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_effect_IO$().fs(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
    this.aXx.pn().bui("Sign Out Failure", x, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_sourcecode_DefinedAt(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsourcecode_File$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsourcecode_File("/home/arturaz/work/chqmate/appClient/src/app/pages/AppPageInit.scala")), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsourcecode_Line$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsourcecode_Line(255)), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsourcecode_FullName$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsourcecode_FullName("app.pages.AppPageInit.logoutIO"))));
  })));
});
$p.a9 = (function(x) {
  return this.Ee(x);
});
$p.a8 = (function(x, default$1) {
  return this.DM(x, default$1);
});
var $d_Lapp_pages_AppPageInit$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_AppPageInit$$anon$1, "app.pages.AppPageInit$$anon$1", ({
  Hq: 1,
  h: 1,
  f: 1,
  g: 1,
  a: 1
}));
export { $d_Lapp_pages_AppPageInit$$anon$1 as $d_Lapp_pages_AppPageInit$$anon$1 };
//# sourceMappingURL=app.pages.-App-Page-Init$$anon$1.js.map
